import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const AddDocument = (props) => (<Svg viewBox="0 0 28 28" {...props}>
    <Path d="M16 16h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 1 0 0-2Zm6-5.06a1.306 1.306 0 0 0-.06-.27v-.09a1.068 1.068 0 0 0-.19-.28l-6-6a1.068 1.068 0 0 0-.28-.19h-.09a.88.88 0 0 0-.33-.11H9a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V10.94Zm-6-3.53L18.59 10H17a1 1 0 0 1-1-1V7.41ZM20 21a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v9Z" fill="#fff"/>
  </Svg>);
export default AddDocument;
